import PropTypes from "prop-types";
// import asArray from "@grebban/array-utils/asArray";
import { asArray } from "core-web/utils/array";
import styled from "theme/libs/styled";

const StyledWrapper = styled("div")`
    display: grid;
`;

const Grid = ({ as, columns, columnGap, rows, rowGap, ...rest }) => (
    <StyledWrapper
        as={as || "div"}
        gridTemplateColumns={asArray(columns).map((column) => `repeat(${column}, 1fr)`)}
        gridTemplateRows={asArray(rows).map((row) => `repeat(${row}, 1fr)`)}
        columnGap={columnGap}
        rowGap={rowGap}
        {...rest}
    />
);

Grid.propTypes = {
    columns: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    ]),
    rows: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    ]),
    columnGap: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    rowGap: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

Grid.defaultProps = {
    as: undefined,
    columns: "12",
    rows: "1",
    columnGap: ["24px", null, null, null, "16px"],
    rowGap: "24px",
};

export default Grid;
